export default __webpack_public_path__ + "static/button-action-do-light-d09aa5192bcb680ca84993a9f0b1668b2f4a116f243b8dc581884961c022a91c.png";